import Link from 'next/link';
import { FC, useEffect } from 'react';
import { StyledStepButtonWrap } from './Styled';
import Heading from '../chat/Heading';
import PrimaryButton from '../chat/Button/PrimaryButton';
import { useNews } from '../../providers/IdentityProvider';

const WalkthroughEnd: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { getNews } = useNews();

  // 利用中のサービスが増えたのため、お知らせ再取得
  useEffect(() => {
    getNews();
  }, []);

  return (
    <>
      <StyledStepButtonWrap>
        <Link href="/dashboard" onClick={onClose}>
          <PrimaryButton label="すぐに使ってみる" />
        </Link>
        <Heading level={5} tag="h2" color="gray" mt="3.75rem" mb="1.5rem">
          さらに詳細な設定をすると便利です。
          <br />
          営業時間設定や、自動応答メッセージなどの設定ができます。
        </Heading>
        <Link
          href={`/service/setting?service=Line`}
          as="/service/setting"
          onClick={onClose}
        >
          <PrimaryButton label="さらに詳細な設定をする" />
        </Link>
      </StyledStepButtonWrap>
    </>
  );
};

export default WalkthroughEnd;
